<template>
	<div id="sre-scene">
		<h2>应用场景</h2>
		<p>维图云管平台让用户轻松管理多云，灵活的可视化编排自动化工具满足不同运维场景、提高生产效率，并且平台可及时反馈成本优化建议，避免云资源浪费。</p>
		<ul class="list">
			<li class="active" v-if="active==1">
				<i class="iconfont icon-icon_duoyunguanli" />
				<h4 style="margin-bottom: 37px;">多云管理</h4>
				<p>
					连接多云，支持一键导入公有云、私有云、物理机等
				</p>
				<p>
					统一纳管，消除各云环境操作差异化，集中管理多云资源
				</p>
			</li>
			<li v-else @mouseenter="activeMe(1)" @click="activeMe(1)">
				<div class="outer">
					<i class="iconfont icon-icon_duoyunguanli" />
				</div>
				<h4>多云管理</h4>
			</li>
			<li class="active" v-if="active==2">
				<i class="iconfont icon-yunwei" />
				<h4 style="margin-bottom: 37px;">便捷运维</h4>
				<p>
					事件驱动型自动化工具，使运维巡检、
					CI/CD更加灵活方便
				</p>
				<p>
					可视化编排自动化工具，满足不同运
					维场景需求
				</p>
			</li>
			<li v-else @mouseenter=" activeMe(2)" @click=" activeMe(2)">
				<div class="outer">
					<i class="iconfont icon-yunwei" />
				</div>
				<h4>便捷运维</h4>
			</li>
			<li class="active" v-if="active==3">
				<i class="iconfont icon-jiangdichengben" />
				<h4 style="margin-bottom: 37px;">降低成本</h4>
				<p>多维度的成本统计分析，使成本开支一目了然
				</p>
				<p>用户可从降低配置、释放闲置资源、调整计费方式等方面自定义优化策略
				</p>
			</li>
			<li v-else @mouseenter=" activeMe(3)" @click=" activeMe(3)">
				<div class="outer">
					<i class="iconfont icon-jiangdichengben" />
				</div>
				<h4>降低成本</h4>
			</li>
			<li class="active" v-if="active==4">
				<i class="iconfont icon-jiaofu" />
				<h4 style="margin-bottom: 37px;">快速交付</h4>
				<p>
					通过自服务快速申请获取资源，提高应用交付速度
				</p>
				<p>基于服务流程的资源申请审批，跨云灵活分配资源</p>
			</li>
			<li v-else @mouseenter=" activeMe(4)" @click=" activeMe(4)">
				<div class="outer">
					<i class="iconfont icon-jiaofu" />
				</div>
				<h4>快速交付</h4>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'SreScene',
		data() {
			return {
				active: 1
			}
		},
		methods: {
			activeMe(index) {
				this.active = index
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		#sre-scene {
			width: 100%;
			height: 640px;
			background-color: rgba(224, 237, 255, 1);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-scene h2 {
			font-size: 36px;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 79px;
		}

		#sre-scene p {
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 37px 0 69px;
		}

		#sre-scene ul {
			display: flex;
			justify-content: space-between;
			width: 75%;
			height: 307px;
		}

		#sre-scene ul li {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 19.5%;
			height: 100%;
			border-radius: 4px;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-scene ul li .outer {
			width: 114px;
			height: 114px;
			border-radius: 50%;
			border: 4px solid #00D5DF;
			opacity: 0.8;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		#sre-scene ul li .outer i {
			margin: 0;
			font-size: 70px;
			color: #00D5DF;
		}

		#sre-scene ul li.active {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			border-radius: 4px;
			background-color: #043F6A;
		}

		#sre-scene ul li i {
			display: block;
			margin: 40px 0 7px;
			font-size: 55px;
			color: #00D5DF;
		}

		#sre-scene ul li.active i {
			background: linear-gradient(0deg, rgba(3, 208, 217, 1), rgba(0, 244, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		#sre-scene ul li h4 {
			text-align: center;
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin-top: 15px;
		}

		#sre-scene ul li.active h4 {
			color: #00EBF6;
		}

		#sre-scene ul li p {
			font-size: 12px;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(51, 51, 51, .8);
			line-height: 20px;
			text-align: left;
			width: 74%;
			margin: 0 36px;
			margin-bottom: 29px;
		}

		#sre-scene ul li.active p {
			color: rgba(157, 221, 224, 1);
		}
	}

	@media(max-width:992px) {
		#sre-scene {
			width: 100%;
			/* height: 640px; */
			background-color: rgba(224, 237, 255, 1);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-scene h2 {
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 35px;
		}

		#sre-scene p {
			font-size: 0.12rem;
			line-height: 1.1;
			width: 90%;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 0.37rem 0 0.69rem;
		}

		#sre-scene ul {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			width: 100%;
		}

		#sre-scene ul li {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 90%;
			border-radius: 4px;
			margin-bottom: 20px;
		}

		#sre-scene ul li .outer {
			width: 0.54rem;
			height: 0.54rem;
			border-radius: 50%;
			border: 1px solid #00D5DF;
			opacity: 0.8;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		#sre-scene ul li .outer i {
			margin: 0;
			font-size: 0.35rem;
			color: #00D5DF;
		}

		#sre-scene ul li.active {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			border-radius: 4px;
			background-color: #043F6A;
		}

		#sre-scene ul li i {
			display: block;
			margin: 0.1rem 0;
			font-size: 0.25rem;
			color: #00D5DF;
		}

		#sre-scene ul li.active i {
			background: linear-gradient(0deg, rgba(3, 208, 217, 1), rgba(0, 244, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		#sre-scene ul li h4 {
			text-align: center;
			font-size: 0.14rem;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin-top: 0.1rem;
		}

		#sre-scene ul li.active h4 {
			color: #00EBF6;
		}

		#sre-scene ul li p {
			font-size: 0.12rem;
			line-height: 1.1;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(51, 51, 51, .8);
			text-align: left;
			width: 80%;
			margin: 0 0.1rem;
			margin-bottom: 0.1rem;
		}

		#sre-scene ul li.active p {
			color: rgba(157, 221, 224, 1);
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreScene.vue